// extracted by mini-css-extract-plugin
export default {"card":"card_rem_card__itdgH","videoBox":"card_rem_videoBox__duWzJ","poster":"card_rem_poster__9u8gi","play":"card_rem_play__73nmW"};